import React, { useEffect } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import { IconButton, Tooltip } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { IsSectionVisible, IsTenant } from "../../../utils/helper";
import { SECTIONS } from "../../../constants/appConstants";
import AssignmentIcon from "@material-ui/icons/Assignment";
import SettingIcon from "@material-ui/icons/Settings";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import "../../../public/css/style.less";
import "./SideNav.less";
import { NavLink, useHistory } from "react-router-dom";
import ContactsOutlined from "@material-ui/icons/ContactsOutlined";
import RadioOutlined from "@material-ui/icons/RadioOutlined";
import EmailOutlined from "@material-ui/icons/EmailOutlined";
import LocalHospitalOutlinedIcon from "@material-ui/icons/LocalHospitalOutlined";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import Badge from "../../../public/img/common/securityBadge.svg";
import ScreenSearchDesktopOutlinedIcon from "@material-ui/icons/PageviewOutlined";
import WelcomeLogo from "../../../public/img/common/welcome.jpg"; 
const useStyles = makeStyles({
	list: {
		width: 250
	},
	fullList: {
		width: "auto"
	}
});
/**
 * Used for rendering Right Side Nav for Mobile view SDC users
 * @param {*} props
 * @returns Right Side Navigation Component
 */
export default function MobileViewNav(props) {
	const classes = useStyles();
	const [state, setState] = React.useState({
		top: false,
		left: false,
		bottom: false,
		right: false
	});

	const [selectedMenu, setSelected] = React.useState(0);
	const history = useHistory();
	const layout = "";

	const handleDrawerClose = selectedIndex => {
		if (selectedIndex != undefined) {
			setSelected(selectedIndex);
		}
	};

	useEffect(() => {
		switch (history.location.pathname) {
			case "/Dashboard":
				setSelected(0);
				break;
			case "/tenant":
				setSelected(1);
				break;
			case "/request":
				setSelected(2);
				break;
			case "/communication":
				setSelected(3);
				break;
			case "/observation":
				setSelected(4);
				break;
			case "/reports":
				setSelected(5);
				break;
			case "/configurations":
				setSelected(6);
				break;
			case "/reporting":
				setSelected(8);
				break;
			case "/securityIncident":
				setSelected(9);
				break;
			case "/sdcgrantaccess":
				setSelected(10);
				break;
			case "/welcome":
					setSelected(11);
					break;
			default:
				break;
		}
	}, [history.location.pathname]);

	/** toggle drawer */
	const toggleDrawer = (anchor, open) => event => {
		if (
			event.type === "keydown" &&
			(event.key === "Tab" || event.key === "Shift")
		) {
			return;
		}

		setState({ ...state, [anchor]: open });
	};

	/** List */
	const list = anchor => (
		<div
			className={clsx(classes.list, {
				[classes.fullList]: anchor === "top" || anchor === "bottom"
			})}
			role={"presentation"}
			onClick={toggleDrawer(anchor, false)}
			onKeyDown={toggleDrawer(anchor, false)}
		>
			<List>
			{IsSectionVisible(SECTIONS.WELCOME) && (
					<NavLink
						onClick={() => toggleDrawer(anchor, false)}
						to={layout + "/welcome"}
					>
						<ListItem button selected={selectedMenu == 11 ? true : false}>
							<ListItemIcon>
								<Tooltip title={"Welcome"} placement={"right"}>
									<img
											style={{
												width: "27px",
												height: "28px",
											}}
											src={WelcomeLogo}
											alt={"logo"}
									/>
								</Tooltip>
							</ListItemIcon>

							<ListItemText primary={"Welcome"} style={{ color: grey[50] }} />
						</ListItem>
					</NavLink>
				)}
				{IsSectionVisible(SECTIONS.DASHBOARD) && (
					<NavLink
						onClick={() => toggleDrawer(anchor, false)}
						to={layout + "/Dashboard"}
					>
						<ListItem button selected={selectedMenu == 0 ? true : false}>
							<ListItemIcon>
								<Tooltip title={"Dashboard"} placement={"right"}>
									<DashboardOutlinedIcon style={{ color: grey[50] }} />
								</Tooltip>
							</ListItemIcon>

							<ListItemText primary={"Dashboard"} style={{ color: grey[50] }} />
						</ListItem>
					</NavLink>
				)}
				{IsSectionVisible(SECTIONS.TENANT) && (
					<NavLink onClick={() => handleDrawerClose(1)} to={layout + "/tenant"}>
						<ListItem button selected={selectedMenu == 1 ? true : false}>
							<ListItemIcon>
								<Tooltip title={"Tenant"} placement={"right"}>
									<ContactsOutlined style={{ color: grey[50] }} />
								</Tooltip>
							</ListItemIcon>

							<ListItemText primary={"Tenant"} style={{ color: grey[50] }} />
						</ListItem>
					</NavLink>
				)}
				{IsSectionVisible(SECTIONS.REQUEST) && (
					<NavLink
						onClick={() => handleDrawerClose(2)}
						to={layout + "/request"}
					>
						<ListItem button selected={selectedMenu == 2 ? true : false}>
							<ListItemIcon>
								<Tooltip title={"Request"} placement={"right"}>
									<RadioOutlined style={{ color: grey[50] }} />
								</Tooltip>
							</ListItemIcon>

							<ListItemText primary={"Request"} style={{ color: grey[50] }} />
						</ListItem>
					</NavLink>
				)}

				{IsSectionVisible(SECTIONS.SDC_GRANT_ACCESS) && (
					<NavLink
						onClick={() => handleDrawerClose(10)}
						to={layout + "/sdcgrantaccess"}
					>
						<ListItem button selected={selectedMenu == 10 ? true : false}>
							<ListItemIcon>
								<Tooltip title={"SDC Grant Access"} placement={"right"}>
									<ScreenSearchDesktopOutlinedIcon
										style={{ color: grey[50] }}
									/>
								</Tooltip>
							</ListItemIcon>

							<ListItemText
								primary={"SDC Grant Access"}
								style={{ color: grey[50] }}
							/>
						</ListItem>
					</NavLink>
				)}

				{IsSectionVisible(SECTIONS.COMMUNICATION) && (
					<NavLink
						onClick={() => handleDrawerClose(3)}
						to={layout + "/communication"}
					>
						<ListItem button selected={selectedMenu == 3 ? true : false}>
							<ListItemIcon>
								<Tooltip title={"Communication"} placement={"right"}>
									<EmailOutlined style={{ color: grey[50] }} />
								</Tooltip>
							</ListItemIcon>

							<ListItemText
								primary={"Communication"}
								style={{ color: grey[50] }}
							/>
						</ListItem>
					</NavLink>
				)}

				{IsSectionVisible(SECTIONS.HSE_INCIDENT_MENU) && (
					<NavLink
						onClick={() => handleDrawerClose(4)}
						to={layout + "/observation"}
					>
						{" "}
						<ListItem button selected={selectedMenu == 4 ? true : false}>
							<ListItemIcon>
								<Tooltip title={"Health And Safety"} placement={"right"}>
									<LocalHospitalOutlinedIcon
										style={{ color: "red", width: "26px", fontSize: "27px" }}
									/>
								</Tooltip>
							</ListItemIcon>

							<ListItemText
								primary={"Health And Safety"}
								style={{ color: grey[50] }}
							/>
						</ListItem>
					</NavLink>
				)}
				{IsSectionVisible(SECTIONS.SECURITY_INCIDENT) && (
					<NavLink
						onClick={() => handleDrawerClose(9)}
						to={layout + "/securityIncident"}
					>
						{" "}
						<ListItem button selected={selectedMenu == 9 ? true : false}>
							<ListItemIcon>
								<Tooltip title={"Security Incident"} placement={"right"}>
									<img
										style={{
											width: "27px",
											height: "28px",
											filter: "brightness(0) invert(1)"
										}}
										src={Badge}
										alt={"logo"}
									/>
									{/* <SecurityOutlined
											style={{ color: grey[50], width: "26px", fontSize: "27px" }}
										/> */}
								</Tooltip>
							</ListItemIcon>

							<ListItemText
								primary={"Security Incident"}
								style={{ color: grey[50] }}
							/>
						</ListItem>
					</NavLink>
				)}
				{(IsSectionVisible(SECTIONS.FACILITY_PERFORMANCE) ||
					IsSectionVisible(SECTIONS.FINANCIAL) ||
					IsSectionVisible(SECTIONS.HEALTH_AND_SAFETY) ||
					IsSectionVisible(SECTIONS.MAINTENANCE) ||
					IsSectionVisible(SECTIONS.SECURITY_AND_OPERATION) ||
					IsSectionVisible(SECTIONS.SITE_PROFILE) ||
					IsSectionVisible(SECTIONS.STAFFING)) && (
					<NavLink
						onClick={() => handleDrawerClose(5)}
						to={layout + "/reports"}
					>
						{" "}
						<ListItem button selected={selectedMenu == 5 ? true : false}>
							<ListItemIcon>
								<Tooltip title={"KPI"} placement={"right"}>
									<AssessmentOutlinedIcon style={{ color: grey[50] }} />
								</Tooltip>
							</ListItemIcon>

							<ListItemText primary={"KPI"} style={{ color: grey[50] }} />
							{/* {open ? <ExpandLess /> : <ExpandMore />} */}
						</ListItem>
					</NavLink>
				)}

				{IsSectionVisible(
					SECTIONS.REPORTING,
					SECTIONS.REPORTING,
					SECTIONS.ADD_EDIT
				) && (
					<NavLink
						onClick={() => handleDrawerClose(8)}
						to={layout + "/reporting"}
					>
						{" "}
						<ListItem button selected={selectedMenu == 8 ? true : false}>
							<ListItemIcon>
								<Tooltip title={"Reporting"} placement={"right"}>
									<AssignmentIcon style={{ color: grey[50] }} />
								</Tooltip>
							</ListItemIcon>

							<ListItemText primary={"Reporting"} style={{ color: grey[50] }} />
						</ListItem>
					</NavLink>
				)}

				{IsSectionVisible(SECTIONS.CONFIGURATION) && (
					<NavLink
						onClick={() => handleDrawerClose(6)}
						to={layout + "/configurations"}
					>
						{" "}
						<ListItem button selected={selectedMenu == 6 ? true : false}>
							<ListItemIcon>
								<Tooltip title={"Configuration Settings"} placement={"right"}>
									<SettingIcon style={{ color: grey[50] }} />
								</Tooltip>
							</ListItemIcon>

							<ListItemText
								primary={"Configurations"}
								style={{ color: grey[50] }}
							/>
							{/* {open ? <ExpandLess /> : <ExpandMore />} */}
						</ListItem>
					</NavLink>
				)}

				{IsSectionVisible(SECTIONS.ABOUT_US) && (
					<NavLink
						onClick={() => handleDrawerClose(7)}
						to={layout + "/aboutUs"}
					>
						{" "}
						<ListItem button selected={selectedMenu == 7 ? true : false}>
							<ListItemIcon>
								<Tooltip title={"About Us"} placement={"right"}>
									<InfoIcon style={{ color: grey[50] }} />
								</Tooltip>
							</ListItemIcon>

							<ListItemText primary={"About Us"} style={{ color: grey[50] }} />
							{/* {open ? <ExpandLess /> : <ExpandMore />} */}
						</ListItem>
					</NavLink>
				)}
			</List>
		</div>
	);

	return (
		<>
			{["right"].map(anchor => (
				<React.Fragment key={anchor} className={"mobile-draw"}>
					<div className={" mobile-draw"}>
						{props.topInitial}
						{!IsTenant() ? (
							<IconButton
								className={"white-button"}
								color={"inherit"}
								aria-label={"open drawer"}
								onClick={toggleDrawer(anchor, !state[anchor])}
							>
								<MenuIcon
									className={"white-button"}
									style={{ color: grey[50] }}
								/>
       </IconButton>) : <></>}
					</div>
					<Drawer
						className={"mobile"}
						anchor={anchor}
						open={state[anchor]}
						onClose={toggleDrawer(anchor, false)}
					>
						{list(anchor)}
					</Drawer>
				</React.Fragment>
			))}
		</>
	);
}
